// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Legislative review application registration.
 */
import { registerApplication } from '../../core/layout-registry'
import { FederalBillsBrowser } from './browsers/FederalBillsBrowser.tsx'
import { MarylandBillsBrowser } from './browsers/MarylandBillsBrowser.tsx'
import { LegislativeReviewAdminSettings } from './components/AdminSettingsPanel'
import './renderer-components/register'

registerApplication({
  id: 'legislative-review',
  name: 'Legislative Review',
  description: 'Browse legislative bills from Maryland and Federal data sources',
  components: [
    {
      id: 'applications/legislative-review',
      label: 'Maryland Bills Browser',
      icon: 'Landmark',
      category: 'application',
      description: 'Browse all cached Maryland bills from mgaleg.maryland.gov',
      order: 20,
      Component: MarylandBillsBrowser,
    },
    {
      id: 'applications/federal-bills-browser',
      label: 'Federal Bills Browser',
      icon: 'Globe',
      category: 'application',
      description: 'Browse all cached federal bills from govinfo.gov',
      order: 21,
      Component: FederalBillsBrowser,
    },
    {
      id: 'applications/legislative-review-settings',
      label: 'Settings',
      icon: 'Settings',
      category: 'application',
      description: 'Configure datasources and sessions for legislative review',
      order: 99,
      Component: LegislativeReviewAdminSettings,
    },
  ],
})
